<template>
    <div class="custom-pagination">
      <!-- الذهاب للصفحة الأولى -->
      <button
        type="button"
        class="btn-page"
        @click="goToPage(1)"
        :disabled="currentPage === 1"
      >
        «
      </button>
  
      <!-- الصفحة السابقة -->
      <button
        type="button"
        class="btn-page"
        @click="goToPage(currentPage - 1)"
        :disabled="currentPage === 1"
      >
        ‹
      </button>
  
      <!-- الصفحات -->
      <div class="pages-container">
        <!-- عرض الصفحات وفق المصفوفة المحسوبة visiblePages -->
        <button
          v-for="page in visiblePages"
          :key="page"
          type="button"
          class="btn-page"
          :class="{ active: page === currentPage }"
          @click="goToPage(page)"
        >
          {{ page }}
        </button>
      </div>
  
      <!-- الصفحة التالية -->
      <button
        type="button"
        class="btn-page"
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        ›
      </button>
  
      <!-- الذهاب للصفحة الأخيرة -->
      <button
        type="button"
        class="btn-page"
        @click="goToPage(totalPages)"
        :disabled="currentPage === totalPages"
      >
        »
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "CustomPagination",
    props: {
      currentPage: {
        type: Number,
        required: true,
      },
      totalPages: {
        type: Number,
        required: true,
      },
    },
    emits: ["page-changed"],
    computed: {
      /**
       * منطق ذكي لعرض عدد محدود من الصفحات:
       * - عند كون totalPages صغيرًا (≤7) نعرضها جميعًا.
       * - وإلا نعرض الصفحات (1,2,3) و(... إن لزم) وصفحات حول الصفحة الحالية و(... إن لزم)
       *   وصفات (totalPages-2, totalPages-1, totalPages).
       */
      visiblePages() {
        if (this.totalPages <= 7) {
          return Array.from({ length: this.totalPages }, (_, i) => i + 1);
        }
        const delta = 1; // عدد الصفحات حول currentPage
        const firstPages = [1, 2, 3];
        const lastPages = [this.totalPages - 2, this.totalPages - 1, this.totalPages];
  
        const start = Math.max(4, this.currentPage - delta);
        const end = Math.min(this.totalPages - 3, this.currentPage + delta);
  
        let pages = [...firstPages];
        if (start > 4) {
          pages.push("...");
        }
        for (let p = start; p <= end; p++) {
          if (p > 3 && p < this.totalPages - 2) {
            pages.push(p);
          }
        }
        if (end < this.totalPages - 3) {
          pages.push("...");
        }
        pages.push(...lastPages);
  
        // إزالة أي تكرار في "..."
        const finalPages = [];
        for (let i = 0; i < pages.length; i++) {
          const value = pages[i];
          if (value === "..." && finalPages[finalPages.length - 1] === "...") {
            continue;
          }
          finalPages.push(value);
        }
        return finalPages;
      },
    },
    methods: {
      goToPage(page) {
        if (page === "..." || page < 1 || page > this.totalPages) return;
        if (page === this.currentPage) return;
        this.$emit("page-changed", page);
      },
    },
  };
  </script>
  
  <style scoped>
  .custom-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px; /* مسافة بين الأزرار */
    margin: 20px 0;
    font-family: "Arial", sans-serif;
  }
  
  /* الأزرار الأساسية */
  .btn-page {
    background-color: #002f49; /* نفس لون أزرار الصفحة */
    color: #fff;
    border: none;
    border-radius: 6px; /* تصميم شبه دائري */
    padding: 8px 14px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    font-weight: 600;
    font-size: 16px;
  }
  
  /* زر مفعّل (لصفحة حالية) */
  .btn-page.active {
    background-color: #ffc107; /* لون أصفر */
    color: #002f49;           /* النص يبرز على الأصفر */
  }
  
  /* التحويم */
  .btn-page:hover {
    background-color: #001f33;
  }
  
  /* عندما يكون الزر معطلاً (مثلاً الذهاب للأولى وأنت في الصفحة الأولى) */
  .btn-page:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* الصفحات (الأزرار الوسطى) */
  .pages-container {
    display: flex;
    gap: 8px;
  }
  </style>
  